import BasicLayout from './BasicLayout'
import BlankLayout from './BlankLayout'

export { BasicLayout, BlankLayout }
